import React from 'react';
import debounce from 'debounce';

import { AutoComplete } from 'antd';

import { _getSearchEnterprises } from '../../services';

const Option = AutoComplete.Option;

class EnterpriseSelector extends React.Component{

	render(){

		const { dataSource } = this.state;

		return (
			<AutoComplete

				style={{ width: 200 }}
				onSelect={this.onSelect}
				onChange={this.onChange}
				optionLabelProp="enterpriseName"
				placeholder="Search Enterprise Name"

			>

			{dataSource.map(
				enterprise => (
					<Option 
						companyName={enterprise.companyName} 
						key={`${enterprise._id}~!@${enterprise.companyName}`}>
						<div>{enterprise.companyName}</div>
					</Option>
				)
			)}

			</AutoComplete>

		)
	}

	constructor(props){
        super(props);
        this.state = {
            dataSource: []
        }

		this.handleSearch = debounce(this.handleSearch, 200);
	}

	onChange = ( searchTerm ) => {
		this.handleSearch( searchTerm );
	}

	onSelect = (e) => {
		this.props.onSelect(e)
	}

	handleSearch = ( value ) => {

		if( !value ){
			return this.setState({
				dataSource: []
			})
		}

		_getSearchEnterprises( value )
			.then( res => {
				this.setState({
					dataSource: res.data
				})
			})
		
	}

}

export default EnterpriseSelector;


// WEBPACK FOOTER //
// ./src/components/vm/enterprise-selector.js